import { render, staticRenderFns } from "./ModalIllustration.vue?vue&type=template&id=0d81921d&"
import script from "./ModalIllustration.vue?vue&type=script&lang=js&"
export * from "./ModalIllustration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d81921d')) {
      api.createRecord('0d81921d', component.options)
    } else {
      api.reload('0d81921d', component.options)
    }
    module.hot.accept("./ModalIllustration.vue?vue&type=template&id=0d81921d&", function () {
      api.rerender('0d81921d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ModalIllustration.vue"
export default component.exports